import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Reveal from "../components/Reveal";

const HERO = "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/x8yn4c4a_barberia_difuminada_16%20%281%29.jpg";
const VAGARO_URL = "https://www.vagaro.com/axtreme/services";
const ADDRESS = "737 SW 109th Ave STE 106, Miami, FL 33174";
const MAP_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`;

const GALLERY = [
  "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/n8eiqf8f_160515.jpg",
  "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/2ajdr6n1_160496.jpg",
  "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/knvy3yh5_160420.jpg",
  "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/q2fuge5k_149940.jpg",
  "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/r7wfe3pj_149939.jpg",
  "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/30fjhdkn_150063.jpg",
  "https://customer-assets.emergentagent.com/job_axtreme-salon/artifacts/xoquad3y_149935.jpg",
];

const MENS_CARD_IMG = "https://images.unsplash.com/photo-1622286342621-4bd786c2447c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
const WOMENS_CARD_IMG = "https://images.unsplash.com/photo-1560869713-7d0a29430803?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const RED = "#CC2222";
const CHARCOAL = "#1A1A1A";
const BODY = "#2C2825";
const LIGHT = "#F5F5F5";

export default function Home() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const i = setInterval(() => setIdx(p => (p + 1) % GALLERY.length), 3000);
    return () => clearInterval(i);
  }, []);
  return (
    <div data-testid="home-page" style={{ background: "#FFFFFF" }}>
      {/* HERO */}
      <section className="relative w-full overflow-hidden" style={{ height: "100vh" }} data-testid="home-hero">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "rgba(0,0,0,0.18)" }} />
        {/* Subtle top gradient — keeps navbar icons readable */}
        <div className="absolute top-0 left-0 right-0 pointer-events-none" style={{ height: "15%", background: "linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%)" }} />
        <div className="relative z-10 h-full max-w-5xl mx-auto px-6 lg:px-8 flex flex-col items-center justify-center text-center text-white" style={{ textShadow: "0 2px 24px rgba(0,0,0,0.45)" }}>
          <div className="text-[11px] tracking-[0.4em] uppercase font-semibold" style={{ color: RED, textShadow: "0 1px 6px rgba(0,0,0,0.55)" }}>Miami, FL</div>
          <h1 className="mt-5 text-5xl sm:text-7xl lg:text-8xl leading-[1.02] text-white" style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, letterSpacing: "-0.02em" }}>
            Where Style Meets <span style={{ color: RED }}>PERFECTION</span>
          </h1>
          <p className="mt-6 max-w-2xl text-lg sm:text-xl italic text-white/95" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
            A decade of craft, color and precision — Discover the AXtreme experience.
          </p>
          <a href={VAGARO_URL} target="_blank" rel="noreferrer" className="mt-10 inline-block px-12 py-4 text-xs tracking-[0.3em] uppercase text-white bg-[#CC2222] hover:bg-[#a81b1b] transition-colors" data-testid="hero-book-now">Book Now</a>
        </div>
        <a
          href={MAP_URL}
          target="_blank"
          rel="noreferrer"
          className="absolute z-10 bottom-8 left-6 lg:left-10 flex items-center gap-2 text-white/95 hover:text-white transition-colors"
          style={{ textShadow: "0 1px 6px rgba(0,0,0,0.5)" }}
          data-testid="hero-location-pin"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          <span className="text-[10px] tracking-[0.3em] uppercase">737 SW 109th Ave · Miami, FL</span>
        </a>
      </section>

      {/* GALLERY — directly below hero */}
      <Reveal>
        <section className="px-6 lg:px-8 py-24" style={{ background: "#FFFFFF" }} data-testid="home-gallery">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-16" style={{ background: RED }} />
              <div className="text-[11px] tracking-[0.4em] uppercase font-semibold" style={{ color: RED }}>Our Work</div>
            </div>
            <h2 className="text-4xl sm:text-5xl mb-10" style={{ color: CHARCOAL, fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>Inside the studio</h2>
            <div className="relative w-full aspect-[16/9] overflow-hidden" style={{ background: "#FFFFFF" }}>
              {GALLERY.map((src, i) => (
                <img
                  key={src}
                  src={src}
                  alt=""
                  className="absolute inset-0 w-full h-full transition-opacity duration-1000"
                  style={{ opacity: i === idx ? 1 : 0, objectFit: "cover", objectPosition: "center top" }}
                />
              ))}
              <button
                onClick={() => setIdx((p) => (p - 1 + GALLERY.length) % GALLERY.length)}
                aria-label="Previous"
                data-testid="gallery-prev"
                className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/90 hover:bg-white transition-colors"
                style={{ color: CHARCOAL, border: "1px solid #E0E0E0" }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
              </button>
              <button
                onClick={() => setIdx((p) => (p + 1) % GALLERY.length)}
                aria-label="Next"
                data-testid="gallery-next"
                className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/90 hover:bg-white transition-colors"
                style={{ color: CHARCOAL, border: "1px solid #E0E0E0" }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
              </button>
            </div>
            <div className="mt-6 flex justify-center gap-2">
              {GALLERY.map((src) => (
                <button
                  key={src}
                  onClick={() => setIdx(GALLERY.indexOf(src))}
                  aria-label={`Go to slide`}
                  data-testid={`gallery-dot-${src.slice(-12)}`}
                  className="w-8 h-1 transition-colors"
                  style={{ background: GALLERY.indexOf(src) === idx ? RED : "#E0E0E0" }}
                />
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      {/* OUR STORY */}
      <Reveal>
        <section className="py-24" style={{ background: LIGHT }} data-testid="home-story">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center gap-4 mb-4">
                <span className="h-px w-16" style={{ background: RED }} />
                <div className="text-[11px] tracking-[0.4em] uppercase font-semibold" style={{ color: RED }}>Our Story</div>
              </div>
              <h2 className="text-4xl sm:text-5xl" style={{ color: CHARCOAL, fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>Crafted, not cut.</h2>
              <p className="mt-6 leading-relaxed max-w-prose" style={{ color: BODY }}>From a single question in Cuba at nineteen, to over a decade of mastery in the heart of Miami — AXtreme Hair Style was built on passion, sacrifice and an unshakable love for the craft. Founded in 2016 by a husband and wife team, every cut, every color and every client is part of a story that keeps growing. Because here, you're not just getting a haircut. You're becoming part of something bigger.</p>
              <Link to="/our-story" className="mt-8 inline-block px-8 py-4 text-xs tracking-[0.3em] uppercase border border-[#CC2222] text-[#CC2222] hover:bg-[#CC2222] hover:text-white transition-colors" data-testid="home-story-cta">Read Our Full Story →</Link>
            </div>
            <div className="relative w-full aspect-[4/5] bg-white overflow-hidden border border-[#E0E0E0]" data-testid="home-story-video">
              <img src="https://images.unsplash.com/photo-1546664278-c0a27e0cdc88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Our Story" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-20 h-20 rounded-full bg-white/95 flex items-center justify-center shadow-xl">
                  <svg width="22" height="26" viewBox="0 0 22 26" fill={CHARCOAL}><polygon points="0,0 22,13 0,26" /></svg>
                </div>
              </div>
              <div className="absolute bottom-4 left-4 right-4 text-white text-[10px] tracking-[0.3em] uppercase opacity-90" style={{ textShadow: "0 1px 4px rgba(0,0,0,0.5)" }}>Video coming soon</div>
            </div>
          </div>
        </section>
      </Reveal>

      {/* SERVICES — minimal cards */}
      <Reveal>
        <section className="py-24" style={{ background: "#FFFFFF" }} data-testid="home-services">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex items-center gap-4 mb-4">
              <span className="h-px w-16" style={{ background: RED }} />
              <div className="text-[11px] tracking-[0.4em] uppercase font-semibold" style={{ color: RED }}>Our Services</div>
            </div>
            <h2 className="text-4xl sm:text-5xl" style={{ color: CHARCOAL, fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>What would you like today?</h2>

            <div className="mt-14 grid md:grid-cols-2 gap-8 lg:gap-12">
              {[
                { k: "mens-studio", label: "Men's Studio", img: MENS_CARD_IMG },
                { k: "womens", label: "Women's Hair", img: WOMENS_CARD_IMG },
              ].map((p) => (
                <Link
                  key={p.k}
                  to={`/services/${p.k}`}
                  className="group block bg-white border border-[#E0E0E0] p-6 sm:p-8 hover:border-[#CC2222] transition-colors duration-300"
                  data-testid={`home-panel-${p.k}`}
                >
                  <div className="w-full aspect-[4/3] overflow-hidden bg-[#F5F5F5] flex items-center justify-center">
                    <img
                      src={p.img}
                      alt={p.label}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                    />
                  </div>
                  <div className="mt-6 text-center">
                    <div className="text-xl sm:text-2xl tracking-[0.18em] uppercase" style={{ color: CHARCOAL, fontFamily: "'Archivo', sans-serif", fontWeight: 700 }}>{p.label}</div>
                    <div className="mx-auto mt-3 mb-5 h-px w-16" style={{ background: RED }} />
                    <div className="text-[11px] tracking-[0.3em] uppercase font-semibold transition-colors" style={{ color: RED }}>
                      View Services →
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      {/* TESTIMONIALS */}
      <Reveal>
        <section className="py-24" style={{ background: LIGHT }} data-testid="home-testimonials">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex items-center gap-4 mb-4">
              <span className="h-px w-16" style={{ background: RED }} />
              <div className="text-[11px] tracking-[0.4em] uppercase font-semibold" style={{ color: RED }}>Testimonials</div>
            </div>
            <h2 className="text-4xl sm:text-5xl" style={{ color: CHARCOAL, fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>What clients say</h2>
            <div className="mt-12 grid md:grid-cols-3 gap-8">
              {[
                { n: "Isabella M.", q: "I left the chair feeling like the best version of myself. The detail in every cut is unmatched." },
                { n: "Marcus T.", q: "The skin fade is a work of art. AXtreme is the only place I trust." },
                { n: "Sophia R.", q: "My balayage feels effortless and luminous — exactly what I asked for and more." },
              ].map((tt, i) => (
                <div key={tt.n} className="p-8 bg-white border border-[#E0E0E0]" style={{ borderBottom: `3px solid ${RED}` }} data-testid={`testimonial-${i}`}>
                  <p className="italic text-lg leading-relaxed" style={{ fontFamily: "'Cormorant Garamond', serif", color: CHARCOAL }}>"{tt.q}"</p>
                  <div className="mt-6 text-xs tracking-[0.3em] uppercase font-semibold" style={{ color: RED }}>— {tt.n}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </Reveal>
    </div>
  );
}
